const LAST_NAVIGATION_KEY = 'milanote.lastNavigation.elementId';

export const setLocalLastNavigationId = (boardId: string) => {
    localStorage.setItem(LAST_NAVIGATION_KEY, boardId);
};

export const getLocalLastNavigationId = (): string | null => {
    return localStorage.getItem(LAST_NAVIGATION_KEY);
};

export const removeLocalLastNavigationId = () => {
    localStorage.removeItem(LAST_NAVIGATION_KEY);
};
